import app from '../app';

app.controller("ContactController", ContactController);

/*@ngInject*/
function ContactController(contactFormFields, apiService, messagesService) {
    var vm = this;
    vm.contactFormModel = {};
    vm.contactFormFields = contactFormFields;
    vm.send = send;

    function send(){
        apiService.sendForm('contact', vm.contactFormModel).then(() => {
            vm.contactFormModel = {};
            messagesService.success({text : "Success"});
        }).error(() => {
            messagesService.success({text : "Error"});
        });
    }
}




// WEBPACK FOOTER //
// ./static/js/app/contact/contact.controller.js